import { render, staticRenderFns } from "./section-oxygen-minus-time-chart.vue?vue&type=template&id=0fad1432&scoped=true"
import script from "./section-oxygen-minus-time-chart.vue?vue&type=script&lang=js"
export * from "./section-oxygen-minus-time-chart.vue?vue&type=script&lang=js"
import style0 from "./section-oxygen-minus-time-chart.vue?vue&type=style&index=0&id=0fad1432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad1432",
  null
  
)

export default component.exports